import Icons from '../../../common/widgets/Icons';
import { BreadcrumbTrail } from '../models/Common';
import { resources } from '../resources/resources';

const applicationCrumbs: (
  translate: (arg: string) => string,
  param?: string,
) => BreadcrumbTrail = (translate, param?) => {
  return {
    home: {
      element: (
        <span className="breadcrumb-home">
          <Icons.Home />
        </span>
      ),
      path: '/',
    },
    myBenefits: {
      element: <span>{translate(resources.menu.myBenefits)}</span>,
      path: '/my-account/my-benefits',
    },
    wishlist: {
      element: <span>{translate(resources.menu.wishlist)}</span>,
      path: '/my-account/wishlist',
    },
    accountDashboard: {
      element: <span>{translate(resources.menu.dashboard)}</span>,
      path: '/my-account/dashboard',
    },
    accountInfo: {
      element: <span>{translate(resources.menu.accountInfo)}</span>,
      path: '/my-account/account-info',
    },
    changePassword: {
      element: <span>{translate(resources.menu.passwordChange)}</span>,
      path: '/my-account/change-password',
    },
    preferences: {
      element: <span>{translate(resources.menu.preferences)}</span>,
      path: '/my-account/preferences',
    },
    notifications: {
      element: <span>{translate(resources.menu.notifications)}</span>,
      path: '/my-account/notifications',
    },
    cards: {
      element: <span>{translate(resources.cards)}</span>,
      path: '/my-account/cards',
    },
    topUpCard: {
      element: <span>{translate(resources.employeeCards.topUp.title)}</span>,
      path: '/my-account/cards/:cardId/top-up',
    },
    transactions: {
      element: (
        <span>
          {translate(resources.employeeCards.transactions.transactions)}
        </span>
      ),
      path: '/my-account/cards/:cardId/transactions',
    },
    vouchers: {
      element: <span>{translate(resources.menu.vouchers)}</span>,
      path: '/my-account/vouchers',
    },
    orders: {
      element: <span>{translate(resources.menu.orders)}</span>,
      path: '/my-account/orders',
    },
    subscriptions: {
      element: <span>{translate(resources.menu.subscriptions)}</span>,
      path: '/my-account/subscriptions',
    },
    timeAndAttendance: {
      element: <span>{translate(resources.menu.timeAndAttendance)}</span>,
      path: '/my-account/time-and-attendance',
    },
    checkIn: {
      element: <span>{translate(resources.menu.checkIn)}</span>,
      path: '/my-account/time-and-attendance/check-in',
    },
    flexibleBenefits: {
      element: <span>{translate(resources.menu.flexibleBenefits)}</span>,
      path: '/flexible-benefits',
    },
    clubBenefits: {
      element: <span>{translate(resources.menu.benefitClub)}</span>,
      path: '/club-benefits',
    },
    discountVouchers: {
      element: <span>{translate(resources.menu.discountVouchers)}</span>,
      path: '/discount-vouchers',
    },
    cashback: {
      element: <span>{translate(resources.menu.cashback)}</span>,
      path: '/cashback',
    },
    search: {
      element: (
        <span>{`${translate(resources.searchPage.crumb)} "${param}"`}</span>
      ),
      path: `/products/search`,
    },
    help: {
      element: <span>{translate(resources.menu.help)}</span>,
      path: `/help`,
    },
    admin: {
      element: <span>{translate(resources.menu.admin)}</span>,
      path: `/admin`,
    },
    employeesAdmin: {
      element: (
        <span>{translate(resources.admin.employees.details.crumbText)}</span>
      ),
      path: `/admin/employee-management`,
    },
    attendanceAdmin: {
      element: <span>{translate(resources.admin.timesheets.crumbText)}</span>,
      path: `/admin/attendance`,
    },
    attendanceSettings: {
      element: (
        <span>{translate(resources.admin.timesheetsSettings.crumbText)}</span>
      ),
      path: `/admin/attendance/timesheet-settings`,
    },
    discover: {
      element: <span>{translate(resources.discover.header)}</span>,
      path: `/discover`,
    },
    discoverParam: {
      element: <span>{`${param}`}</span>,
      path: `/discover/${param}`,
    },
    discoverByLocation: {
      element: (
        <span>{`${translate(resources.searchPage.crumb)} "${param}"`}</span>
      ),
      path: `/discover/benefitsIn/${param}`,
    },
    demoAccount: {
      element: <span>{translate(resources.demoAccount.title)}</span>,
      path: '/my-account/create-demo-account',
    },
  };
};

export default applicationCrumbs;
